export default __webpack_public_path__ + "static/media/place.207cb214.svg";